import { supabase } from '../lib/supabase';

export const authService = {
  async signUp(email, password, fullName, role = 'cliente') {
    const { data, error } = await supabase?.auth?.signUp({
      email,
      password,
      options: {
        data: {
          full_name: fullName,
          role: role
        },
        emailRedirectTo: window.location?.origin
      }
    });
    if (error) throw error;
    return data;
  },

  async signIn(email, password) {
    const { data, error } = await supabase?.auth?.signInWithPassword({ email, password });
    
    // Check for email confirmation error
    if (error) {
      if (error?.message?.includes('Email not confirmed')) {
        throw new Error('Devi confermare la tua email prima di accedere. Controlla la tua casella di posta.');
      }
      if (error?.message?.includes('Invalid login credentials')) {
        throw new Error('Email o password non corretti. Riprova.');
      }
      throw error;
    }
    
    return data;
  },

  async signOut() {
    const { error } = await supabase?.auth?.signOut();
    if (error) throw error;
  },

  async getCurrentUser() {
    const { data: { user }, error } = await supabase?.auth?.getUser();
    if (error) throw error;
    return user;
  },

  async getUserProfile(userId) {
    const { data, error } = await supabase?.from('user_profiles')?.select('*')?.eq('id', userId)?.single();
    if (error) throw error;
    return data;
  }
};